// extracted by css-extract-rspack-plugin
export default {"right":"Right_right__qRK21","uploadWrapper":"Right_uploadWrapper__8KJ0a","mobile":"Right_mobile__U-bV2"};